export default "__VITE_ASSET__DVOU1UAo__"